var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1935.118,
    height: 1935.118,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.836 320.85c0-123.447.975-141.523 7.775-144.132 4.277-1.64 7.375-6.914 6.885-11.718-.49-4.803-.633-16.004-.318-24.89l.573-16.156h84.512v21.474c0 16.71 2.757 23.871 12.428 32.28l12.428 10.806V462H212.838zm28.388-204.965c-1.942-1.942-3.531-8.516-3.531-14.609 0-9.303-3.202-11.382-19.992-12.984-10.996-1.048-22.031.132-24.523 2.624-9.482 9.483-19.837-1.02-19.145-19.422.75-19.924 9.764-26.799 21.917-16.713 11.032 9.157 41.036 9.897 45.94 1.135 2.872-5.132 11.49-6.685 30.962-5.579l26.981 1.534v64.626l-27.539 1.46c-15.146.802-29.128-.132-31.07-2.071z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotion);
export default __webpack_public_path__ + "static/media/lotion.1dafb2ee.svg";
export { ForwardRef as ReactComponent };